import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';

function ContactDepartmentListTemplate({ contactDepartmentListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization
    } = contactDepartmentListViewStore;
    return (
        <ApplicationListLayout store={contactDepartmentListViewStore}>
            <Content  emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility}/>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='CONTACT_DEPARTMENT.LIST.EMPTY_STATE.TITLE' description='CONTACT_DEPARTMENT.LIST.EMPTY_STATE.DESCRIPTION' />
}

ContactDepartmentListTemplate.propTypes = {
    contactDepartmentListViewStore: PropTypes.object
};

export default defaultTemplate(ContactDepartmentListTemplate);
